import { useParams } from 'react-router-dom';
import { useSubmissionQuery } from '../lib/PublicQueries';
import FormThankYou from '../components/FormThankYou';
import Loading from '../../components/Loading';
import ThemedForm from '../../components/forms/ThemedForm';
import PageContainer from '../components/PageContainer';
import FormBackgroundContainer from '../../components/forms/FormBackgroundContainer';
import { useSetCurrency } from '../../lib/CurrencyHelpers';
import ErrorMessage from '~/components/ErrorMessage';
import ThemedConfirmationContainer from '~/public/components/ThemedConfirmationContainer';
import { useSetLocale } from '~/lib/useSetLocale.js';
import { cleanContext } from '~/public/lib/ConversionEventTracking.js';

const ConfirmationPage = ({}) => {
    const { token } = useParams();
    const { data, isLoading } = useSubmissionQuery(token);

    useSetLocale(data?.context);

    return (
        <ThemedConfirmationContainer
            token={token}
            children={data => (
                <FormThankYou
                    sections={data?.sections}
                    form={data?.form}
                    formSubmissionResults={data}
                />
            )}
        />
    );
};

export default ConfirmationPage;
